import React from "react"
import ScheduleTabs from "../components/schedule-templates/ScheduleTabs"
import NavButtons from "../components/schedule-templates/NavButtons"

function ScheduleTemplates({ sidebarOpen }) {
	return (
		<div className="schedule-templates-container">
			<div className={`${sidebarOpen ? "pl-64" : "pl-8"}`}>
				<div className="my-5 flex h-auto sm:h-16 flex-col sm:flex-row items-start sm:items-center justify-between bg-white px-4 sm:px-6 lg:px-8 print-hidden">
					<h1 className="font-bold text-4xl font-manrope text-custom-blue mb-4 sm:mb-0">
						Schedule Templates
					</h1>
				</div>

				<div className="bg-white px-4 sm:px-6 lg:px-8 print-hidden">
					<div className="flex flex-wrap items-center gap-x-4 sm:gap-x-6">
						<NavButtons />
					</div>
				</div>

				<main className="py-10 print:block">
					<div className="px-4 sm:px-6 lg:px-8">
						<div className="text-center print:text-left">
							<ScheduleTabs />
						</div>
					</div>
				</main>
			</div>
		</div>
	)
}

export default ScheduleTemplates
